import React, {useMemo } from 'react';
import {useAuth} from "../../providers/AuthProvider";
import {Empty, Select, Timeline} from 'antd';
import {usePositionOverride} from "../../providers/PositionOverrideProvider";
import {usePosition} from "../../providers/ProjectPositionProvider";
import SpinLoader from "../../components/SpinLoader";
import {CheckCircleFilled, WarningTwoTone,CheckCircleTwoTone,CloseCircleFilled, LoadingOutlined} from "@ant-design/icons";

const {Option} = Select;
//

const CandidateGreenlightWorkflow = ({onClose}) => {
    const {auth} = useAuth();
    const {position, isLoading} = usePosition();
    const {updateTaxPreference, isDisabled} = usePositionOverride();
    const candidate = position.assigned_candidate;
    const candidateTaxPreference = useMemo(() => {
        if (!candidate?.client_tax_preference) {
            return undefined;
        }
        switch (candidate.client_tax_preference) {
            default:
            case "ic-only":
            case "ee-only":
                return candidate.client_tax_preference
            case "ic-preferred":
            case "any":
                return 'any'
        }
    }, [position, isDisabled])

    const workflowItems = useMemo(() => {
        if (!candidate.tax_workflow?.length) {
            return []
        }

        let lastItemIcon = undefined;
        let lastItemColor = undefined;
        switch (candidate.tax_classify_status) {
            case "Pending":
                lastItemIcon = <LoadingOutlined/>;
                break
            case "Passed":
                lastItemIcon = <CheckCircleFilled/>;
                lastItemColor = TB.config('color.success');
                break
            case "Failed":
                lastItemIcon = <CloseCircleFilled/>;
                lastItemColor = TB.config('color.danger');
                break
        }
        let items = TB.map(candidate.tax_workflow || [], (item, index) => {
            let color, icon;
            switch (item.name) {
                default:
                case "Worker Invite Accepted":
                case "Classification Completed":
                    break;
                case "Worker Invited":
                case "Worker Onboarding Started":
                case "Worker Onboarding Submitted":
                    color = "gray";
                    break;
                case "Background Check Completed":
                    if (candidate.background_check_status  === 'Passed') {
                        color = "green";
                    }
                    if (candidate.background_check_status  === 'Failed') {
                        color = "red";
                    }
                    break;
                case "Worker Invite Idle":
                case "Worker Onboarding Stalled":
                    icon = <WarningTwoTone twoToneColor={TB.config("color.danger")}/>;
                    break;
                case "Job Approved":
                    icon = <CheckCircleTwoTone twoToneColor={TB.config("color.success")}/>;
                    break;
            }
            return {
                ...item,
                icon,
                color
            }
        })
        return [{
                name: "Request Started",
                triggered_at: TB.first(candidate.tax_workflow).triggered_at,
                icon: undefined,
                color: 'black'
            }, ...items, {
            name: candidate.tax_classify_status === "Pending" ? "In Progress..." : candidate.tax_classify_status,
            icon: lastItemIcon,
            color: lastItemColor
        }]
    }, [])
    return (
        <SpinLoader isLoading={isDisabled}>
            <div>

                <h4 className="scheduler-header">
                    GreenLight Onboarding Workflow
                </h4>
                <div className="mt-9">
                    {workflowItems?.length > 0 ? (
                        <Timeline
                            mode="alternate">
                            {TB.map(workflowItems, (item, i) => (
                                <Timeline.Item
                                    key={`ctwi-${i}`}
                                    dot={item.icon}
                                    color={item.color}
                                >
                                    <div className={TB.mapClass("flex flex-col gap-0.5", {
                                        "pt-[5px]": !item.triggered_at
                                    })}>
                                        <p className="whitespace-no-wrap text-sm">
                                            {item.name}
                                        </p>
                                        {item.triggered_at && (
                                            <p className="whitespace-no-wrap text-xs font-medium">
                                                {TB.moment(item.triggered_at).format('ll @ h:mmA')}
                                            </p>
                                        )}
                                    </div>
                                    {item.updates?.length > 0 && item.updates.map((update, j) => (
                                        <div key={`cwi-${i}-update-${j}`}
                                             className={`pl-3 text-xs text-muted ${j === 0 ? 'mt-2' : ''}`}>
                                            <span>
                                                {update.label}:&nbsp;
                                            </span>
                                            <span className={TB.mapClass("font-semibold", {
                                                "text-danger": update.value === "Failed"
                                            })}>
                                                {update.value}
                                            </span>
                                        </div>
                                    ))}
                                </Timeline.Item>
                            ))}
                        </Timeline>
                    ) : (
                        <Empty description="Onboarding Workflow not found"
                               image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                    )}

                </div>
            </div>
        </SpinLoader>
    );
}

export default CandidateGreenlightWorkflow;